import React from 'react';
import Slider from 'react-slick';

class LoginFeatures extends React.Component {
  render() {
    const settings = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4500,
    };

    return (
      <div>
        <Slider {...settings}>
          <div className="l-login__gallery-slide">
            <div className="l-login__gallery-flair flair flair--primary-inverse flair--transparent">
              New Feature
            </div>
            <h3 className="l-login__gallery-title t-login-gallery-title">
              Introducing MQL+ leads
            </h3>
            <h4 className="l-login__gallery-subtitle t-login-gallery-subtitle">
              Prospects at the consideration stage with low cost-per-lead pricing.
            </h4>
          </div>
          <div className="l-login__gallery-slide">
            <div className="l-login__gallery-flair flair flair--primary-inverse flair--transparent">
              <a className="no-link-style" target="_blank" href="https://prospectpath.com/blog/middle-of-funnel-marketing">New Blog</a>
            </div>
            <h3 className="l-login__gallery-title t-login-gallery-title">
              <a className="no-link-style" target="_blank" href="https://prospectpath.com/blog/middle-of-funnel-marketing">Magic in the Middle</a>
            </h3>
            <h4 className="l-login__gallery-subtitle t-login-gallery-subtitle">
              <a className="no-link-style" target="_blank" href="https://prospectpath.com/blog/middle-of-funnel-marketing">
                Why the middle of funnel is your secret weapon for lead generation
              </a>
            </h4>
          </div>
        </Slider>
      </div>
    );
  }
}

export default LoginFeatures;
